import React from 'react';
import './About.scss';
import BreadCrumb from '../BreadCrumb/BreadCrumb';

const About = () => {
  return (
    <>
    <BreadCrumb paths={[{name:"Home",path:"/dashboard"},{
        name:"About Us",path:""
    }]}/>
    <div className="about-container">
      <section className="intro">
      <h2>Who We Are</h2>
<p><strong>At Aerial Borne, we connect precision with purpose.</strong></p>

<p>We are building India's trusted marketplace for professional drone services—linking businesses and individuals with certified, experienced drone operators. Whether it's for aerial surveys, inspections, mapping, or creative projects, Aerial Borne ensures every flight meets high standards of quality, compliance, and safety.</p>

      </section>

      <section className="drone-operator">
      <h2>For Certified Drone Operators</h2>

<h3>Why We Built This</h3>
<p>Being a certified drone pilot means carrying the responsibility of safety, compliance, and professionalism. But getting consistent, high-quality work shouldn’t be another challenge. Aerial Borne connects you directly to real clients who value your expertise.</p>

<h3>Who You Are</h3>
<p>You’re a trained RPAS operator, licensed and field-tested. You take pride in precision work and want a platform that respects your time, equipment, and qualifications.</p>

<h3>What You Get</h3>
<ul>
  <li>Access to verified job opportunities</li>
  <li>Project details upfront—no guesswork</li>
  <li>On-time payments and professional communication</li>
  <li>Freedom to choose what missions you take</li>
</ul>

<h3>Our Mission</h3>
<p>To build India’s most trusted network of drone professionals. We’re here to make your work more visible, more valuable, and more consistent.</p>

      </section>

      <section className="customer">
      <h2>For Customers</h2>

<h3>Why We Started</h3>
<p>Hiring a drone operator shouldn't be a guessing game. Too many businesses waste time navigating inconsistent service providers and unclear credentials. We built Aerial Borne to bring clarity, compliance, and confidence to drone services in India.</p>

<h3>Who We Serve</h3>
<p>We support professionals and businesses that need reliable aerial operations—whether you're in construction, agriculture, utilities, real estate, or media. If precision, safety, and verified results matter to you, we’re built for you.</p>

<h3>What You Can Expect</h3>
<ul>
  <li>Certified and insured operators</li>
  <li>Transparent pricing and project scopes</li>
  <li>Services aligned with DGCA regulations</li>
  <li>End-to-end support across mission types</li>
</ul>

<h3>Our Purpose</h3>
<p>To make drone services dependable. We reduce risk, save time, and help you move forward with confidence—on the ground and in the air.</p>

      </section>
    </div>
    </>
  );
};

export default About;
